import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isObject, variant, createMediaQuery } from 'styled-system';
import { mergeAll, mapObj } from '../utils';
export var mapScales = function mapScales(breakpoints, variantDict, scaleProps) {
  return mapScalesFn(breakpoints, function (prop) {
    return variantDict[prop];
  }, scaleProps);
};
export var mapScalesFn = function mapScalesFn(breakpoints, styleGetter, scaleProps) {
  var styles = [];

  if (Array.isArray(scaleProps)) {
    styles.push(styleGetter(scaleProps[0]));

    for (var i = 1; i < scaleProps.slice(0, breakpoints.length + 1).length; i++) {
      if (styleGetter(scaleProps[i])) {
        styles.push(_defineProperty({}, createMediaQuery(breakpoints[i - 1]), styleGetter(scaleProps[i])));
      }
    }
  } else {
    for (var key in scaleProps) {
      var breakpoint = breakpoints[key];
      var media = createMediaQuery(breakpoint);
      var rules = styleGetter(scaleProps[key]);

      if (!breakpoint) {
        styles.unshift(rules);
      } else {
        styles.push(_defineProperty({}, media, rules));
      }
    }

    styles.sort();
  }

  return mergeAll.apply(void 0, styles);
};
export var makeScaledArrayStyles = function makeScaledArrayStyles(_ref) {
  var theme = _ref.theme,
      styleObjArr = _ref.styleObjArr;
  return styleObjArr.reduce(function (acc, styleObj, i) {
    return [].concat(_toConsumableArray(acc), [i === 0 ? styleObj : _defineProperty({}, createMediaQuery(theme.breakpoints[i - 1]), styleObj)]);
  }, []);
};
export var makeScaledObjStyles = function makeScaledObjStyles(_ref3) {
  var theme = _ref3.theme,
      styleObjMap = _ref3.styleObjMap;
  var styles = [];

  for (var bpName in styleObjMap) {
    var bp = theme.breakpoints[bpName];
    var mediaQuery = createMediaQuery(bp);

    if (!bp) {
      styles.unshift(styleObjMap[bpName]);
    } else {
      styles.push(_defineProperty({}, mediaQuery, styleObjMap[bpName]));
    }
  }

  styles.sort();
  return styles;
};
/**
 * Just like styled-system's `variant` but with scaled array support, allowing
 * users to do things like `<Buttom variant={["primary", "secondary"]} />`
 * @param {string} props.key
 * @param {string} props.prop
 * @returns {function}
 */

export var scaledVariant = function scaledVariant(_ref4) {
  var key = _ref4.key,
      _ref4$prop = _ref4.prop,
      prop = _ref4$prop === void 0 ? 'variant' : _ref4$prop;
  return function (props) {
    // single option selected, e.g. variant="h1Emph"
    if (!isObject(props[prop])) {
      return variant({
        key: key,
        prop: prop
      })(props);
    } // multiple options selected, e.g. variant={["h3Emph", "h1Emph"]} or variant={{ sm: "h3Emph", md: "h1Emph" }}


    return mapScales(props.theme.breakpoints, props.theme[key], props[prop]);
  };
};
/**
 * Apply a function to a scaled value, regardless of its container type or
 * lack thereof.
 */

export var mapScaledPropValue = function mapScaledPropValue(fn, scaledVal) {
  return Array.isArray(scaledVal) ? scaledVal.map(fn) : typeof scaledVal === 'string' ? fn(scaledVal) : mapObj(fn, scaledVal);
};